if (!customElements.get('partners-marquee')) {
  customElements.define(
    'partners-marquee',
    class PartnersMarquee extends HTMLElement {
      constructor() {
        super();
        this.track = this.querySelector('.partners__list');
        this.speed = 40; // px per second
        this.position = 0;
        this.paused = false;
        this.rafId = null;
        this.lastTimestamp = null;
        this.loopWidth = 0;
        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

        this.onMobileChange = this.onMobileChange.bind(this);
        this.pause = this.pause.bind(this);
        this.resume = this.resume.bind(this);
        this.tick = this.tick.bind(this);
      }

      connectedCallback() {
        if (!this.track || !this.track.children.length) return;

        this.originalItems = Array.from(this.track.children);

        this.mobileQuery.addEventListener('change', this.onMobileChange);
        this.addEventListener('pointerenter', this.pause);
        this.addEventListener('pointerleave', this.resume);
        this.addEventListener('focusin', this.pause);
        this.addEventListener('focusout', this.resume);

        this.onMobileChange();
      }

      disconnectedCallback() {
        this.stop();
        this.mobileQuery.removeEventListener('change', this.onMobileChange);
      }

      onMobileChange() {
        if (this.mobileQuery.matches) {
          this.setupLoop();
          this.start();
        } else {
          this.stop();
          this.teardownLoop();
        }
      }

      setupLoop() {
        if (this.loopWidth) return;

        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const first = this.originalItems[0];
        const last = this.originalItems[this.originalItems.length - 1];
        this.loopWidth = last.offsetLeft + last.offsetWidth - first.offsetLeft + gap;

        const minWidth = this.offsetWidth + this.loopWidth;
        while (this.track.scrollWidth < minWidth) {
          this.originalItems.forEach((item) => {
            const clone = item.cloneNode(true);
            clone.setAttribute('aria-hidden', 'true');
            clone.setAttribute('inert', '');
            this.track.appendChild(clone);
          });
        }
      }

      teardownLoop() {
        this.track.querySelectorAll('[aria-hidden="true"]').forEach((clone) => clone.remove());
        this.track.style.transform = '';
        this.loopWidth = 0;
        this.position = 0;
      }

      start() {
        if (this.rafId || this.reducedMotionQuery.matches) return;
        this.lastTimestamp = null;
        this.rafId = requestAnimationFrame(this.tick);
      }

      stop() {
        if (this.rafId) cancelAnimationFrame(this.rafId);
        this.rafId = null;
      }

      pause() {
        this.paused = true;
      }

      resume() {
        this.paused = false;
      }

      tick(timestamp) {
        if (this.lastTimestamp === null) this.lastTimestamp = timestamp;
        const delta = timestamp - this.lastTimestamp;
        this.lastTimestamp = timestamp;

        if (!this.paused && this.loopWidth) {
          this.position = (this.position + (this.speed * delta) / 1000) % this.loopWidth;
          this.track.style.transform = `translateX(-${this.position}px)`;
        }

        this.rafId = requestAnimationFrame(this.tick);
      }
    }
  );
}
